import React, {useContext, useState, useEffect} from "react";
import Introduction from "./Introduction";
import showContext from "../context/ShowContext";

export default function Main() {
    const {isRendered} = useContext(showContext)
    const [isVisible, setIsVisible] = useState(false);
    
    useEffect(() => {
        // Check if user has interacted before
        const hasInteracted = sessionStorage.getItem('hasInteracted');
        
        if (hasInteracted) {
            setIsVisible(true);
        }
        
        // Function to check if hero is reduced
        const checkHeroState = () => {
            const hasInteracted = sessionStorage.getItem('hasInteracted');
            if (hasInteracted) {
                setIsVisible(true);
            }
        };
        
        // Set up interval to check hero state
        const interval = setInterval(checkHeroState, 500);
        
        // Clean up interval
        return () => clearInterval(interval);
    }, []);
    
    const mainStyle = {
        opacity: isVisible ? 1 : 0,
        transition: 'opacity 0.5s ease-in-out',
        visibility: isVisible ? 'visible' : 'hidden'
    };
    
    return (
        <div className="main-container" style={mainStyle}>

            <div className={` main ${isVisible}`}>

                <Introduction/>

                
            </div>
            
        </div>
    )
}